export enum ActiveRoleEnum {
  cecb = 'CECB',
  readOnly = 'READ_ONLY',
  admin = 'ADMIN',
  api = 'API',
  secretary = 'SECRETARY',
  expert = 'EXPERT',
  scpi = 'SCPI',
  administrationCommunal = 'ADMINISTRATION_COMMUNAL'
}
